import LabModeTypes from '~/constants/types/LabModeTypes';
import {getMode} from '~/utils/url';
import {DEFAULT_MODE} from '~/constants/LabModes';

export function setLabMode() {
  return dispatch => {
    dispatch({
      type: LabModeTypes.UPDATE_LAB_MODE,
      payload: getMode()
    });
  };
}

export function resetLabMode() {
  return dispatch => {
    dispatch({
      type: LabModeTypes.UPDATE_LAB_MODE,
      payload: DEFAULT_MODE
    });
  };
}
